/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Individual criterion within a dimension's rubric
 */
export interface RubricScoringCriterion {
  /** Name of the criterion */
  name: string;
  /** Points awarded for this criterion */
  pts: number;
  /** Description of what is required to achieve this criterion */
  descriptor: string;
  /** If this criterion is not met, the whole dimension fails (0 points) */
  dimension_critical?: boolean;
  /** Criterion is active only when every named param is present and > 0; empty means always active */
  active_when_all_positive?: string[];
}
